import * as ko from "knockout";
import * as _ from "underscore";
import { App } from "../app";
import { Api } from "../app-api";

const divRoot: HTMLDivElement = document.querySelector("#ko-forgot-password");
const divModel: HTMLDivElement = document.querySelector("#divUserForgotPasswordModel");

export class ViewModel {
    busy = ko.observable(false);
    email = ko.observable();

    submit: () => void

    constructor() {
        let self = this;

        self.busy.subscribe(newVal => App.busy(newVal));

        self.submit = () => {
            if (!self.busy() && self.validate())
                self.save();
        }
    }

    private save() {
        let self = this;

        self.busy(true);

        var data = { email: self.email() }

        Api.ForgotPassword(data)
            .done(results => {
                if (results.error) { App.alertError(results.message); return; }
                App.alertSuccess(results.message);
            })
            .always(() => self.busy(false));
    }

    private validate(): boolean {
        let self = this;

        if (!App.validateEmail(self.email())) { alert("Invalid Email"); return false; }

        return true;
    }
}

function init() {
    if (divModel) {
        ko.applyBindings(new ViewModel(), divRoot);
    }
}

$(document).ready(() => init());